import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useElementForkRef } from '@cian/react-utils';
import { Popper } from '../../../internal/components/Popper';
import { PREVENT_OVERFLOW, FLIP } from '../../../internal/components/Popper/modifiers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонента для открытия выпадающего контента с привязкой к элементу
 */
export function Popover(props) {
  var open = props.open,
    content = props.content,
    preventOverflow = props.preventOverflow,
    flip = props.flip,
    placement = props.placement;
  var _useElementForkRef = useElementForkRef(props.children),
    _useElementForkRef2 = _slicedToArray(_useElementForkRef, 2),
    refferedChildren = _useElementForkRef2[0],
    childrenRef = _useElementForkRef2[1];
  var modifiers = React.useMemo(function () {
    return [flip && FLIP, preventOverflow && PREVENT_OVERFLOW].filter(Boolean);
  }, [flip, preventOverflow]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [refferedChildren, /*#__PURE__*/_jsx(Popper, {
      open: open,
      anchorRef: childrenRef,
      placement: placement,
      modifiers: modifiers,
      children: content
    })]
  });
}